<template>
  <div class="gallery-images-container">
    <gallery-edit-card
      class="gallery-image-card"
      v-for="(img, index) in images"
      :imgData="img"
      :key="img.id"
      :categories="categories"
      :index="index + '-image-card'"
      :saveImageData="saveImageData"
      :handleDeleteImageClick="handleDeleteImageClick"
      :handleImageClick="onClickImage"
    />
  </div>
</template>

<script>
import GalleryEditCard from "./GalleryEditCard.vue";
export default {
  name: "galleryimagelistcontainer",
  props: ["images", "saveImageData", "handleDeleteImageClick", "categories", "onClickImage"],
  components: { GalleryEditCard },
};
</script>

<style lang='scss'>
@import "../styles/colors.scss";
.gallery-images-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  & .gallery-image-card {
    border-radius: 5px;
    width: 32%;
    margin-bottom: 20px;
    background-color: #fff;
    box-shadow: 0 0 3px rgb(202, 202, 202);
    .edit-image-title-field {
      background-color: #f0fbff;
      box-shadow: 0 0 0 1px #75c5e4;
      width: calc(100% - 40px);
      border-radius: 4px;
      margin: 10px 10px 2px 10px;
    }
    .header {
      align-items: center;
      width: 96%;
      margin: 0 auto;
      padding: 5px;
      .image-name {
        display: block;
        font-size: 1.1rem;
        color: gray;
      }
      button {
        color: red;
        padding: 6px 10px;
        background-color: transparent;
        &:hover {
          background-color: red;
          color: #fff;
        }
      }
    }
    .edit-container {
      button {
        padding: 8px 10px;
        background-color: $green;
      }
    }
    span.green {
      color: $green;
      font-weight: bold;
    }
    span.red {
      color: $red;
      font-weight: bold;
    }
    .gray {
      color: gray;
    }
    .cat-label {
      display: block;
      width: 96%;
      margin: 10px auto 0 auto;
      color: gray;
    }
    select {
      width: 100%;
      background-color: #f0fbff;
      box-shadow: 0 0 0 1px #75c5e4;
      padding: 11px 0;
      cursor: pointer;
      border-radius: 4px;
    }
    .bottom-button-group {
      width: 96%;
      margin: 12px auto 12px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      button {
        padding: 6px 10px;
      }
    }
    option {
      font-size: 1.2rem;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    ul {
      width: 98%;
      margin: 14px auto;
      li {
        display: flex;
        justify-content: space-between;
        padding: 4px 6px 15px 6px;
        align-items: center;
      }
    }
    @media screen and (max-width: 1050px) {
      & {
        width: 48%;
      }
    }
    @media screen and (max-width: 550px) {
      & {
        width: 98%;
      }
    }
  }
}
</style>